import { render, staticRenderFns } from "./AppWorkspaceMenu.vue?vue&type=template&id=f747e64a&scoped=true"
import script from "./AppWorkspaceMenu.vue?vue&type=script&lang=js"
export * from "./AppWorkspaceMenu.vue?vue&type=script&lang=js"
import style0 from "./AppWorkspaceMenu.vue?vue&type=style&index=0&id=f747e64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f747e64a",
  null
  
)

export default component.exports